module.exports = __webpack_public_path__ + "img/people_process_tech_8x.5b6079cd.png";